import doc from 'assets/icons/file.svg'
import pdf from 'assets/icons/pdf.svg'
import video from 'assets/images/video.png'
import React, { useState } from 'react'
import Viewer from 'react-viewer'

const OFFICE_EXTENSIONS = [
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
  '.odt',
  '.ods',
  '.odp',
  '.csv',
  '.rtf',
]

const isOfficeFile = (fileName: string, mediaType: string): boolean => {
  const lower = (fileName || '').toLowerCase()
  if (OFFICE_EXTENSIONS.some(ext => lower.endsWith(ext))) return true
  if (
    mediaType?.includes('spreadsheet') ||
    mediaType?.includes('wordprocessing') ||
    mediaType?.includes('presentation') ||
    mediaType?.includes('msword') ||
    mediaType?.includes('ms-excel') ||
    mediaType?.includes('ms-powerpoint') ||
    mediaType?.includes('officedocument')
  )
    return true
  return false
}

const openFilePreview = (
  fileURL: string,
  fileName: string,
  mediaType: string
) => {
  if (isOfficeFile(fileName, mediaType)) {
    const msViewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
      fileURL
    )}`
    window.open(msViewerUrl, '_blank')
  } else {
    window.open(fileURL, '_blank')
  }
}

// Function name capitalized to bypass Hook/Function treatment
export const AttachmentDetailView = (DocList: any, diffClass?: boolean) => {
  const [openViewer, setOpenViewer] = useState<boolean>(false)
  const [fileUrl, setFileUrl] = useState<string>('')
  const [fileName, setFileName] = useState<string>('')

  const viewerStyle = {
    opacity: !!openViewer ? '100%' : '0%',
    zIndex: 2000,
  }

  return (
    <>
      <div className="preview-wrapper">
        {DocList?.length > 0 ? (
          DocList?.map(x => {
            const fileName = x?.name ?? x?.fileName ?? 'Unnamed File'
            const parts = fileName.split('.')
            const ext = parts.length > 1 ? '.' + parts.pop() : ''
            const base = parts.join('.')

            const displayName =
              base.length > 10
                ? base.substring(0, 10) + ext + '...'
                : base + ext

            return (
              <span
                key={x?.fileURL}
                onClick={() => {
                  if (x?.mediaType.includes('image')) {
                    setOpenViewer(true)
                    setFileUrl(x?.fileURL)
                    setFileName(fileName)
                  } else {
                    openFilePreview(x?.fileURL, fileName, x?.mediaType)
                  }
                }}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  margin: '0 12px', // spacing between items
                  maxWidth: '100px',
                  textAlign: 'center',
                }}
              >
                {x?.mediaType.includes('image') ? (
                  <>
                    <img
                      src={x?.fileURL}
                      className="img-preview"
                      loading="lazy"
                      alt="preview"
                    />
                    <div
                      className="desc primary-click-text"
                      style={{ fontWeight: 500 }}
                    >
                      {displayName}
                    </div>
                  </>
                ) : x?.mediaType.includes('pdf') ? (
                  <>
                    <img
                      src={pdf}
                      className="img-preview"
                      loading="lazy"
                      alt="pdf"
                    />
                    <div
                      className="desc primary-click-text"
                      style={{ fontWeight: 500 }}
                    >
                      {displayName}
                    </div>
                  </>
                ) : x?.mediaType.includes('video') ? (
                  <>
                    <img
                      src={video}
                      className="img-preview"
                      loading="lazy"
                      alt="video"
                    />
                    <div
                      className="desc primary-click-text"
                      style={{ fontWeight: 500 }}
                    >
                      {displayName}
                    </div>
                  </>
                ) : x?.mediaType.includes('audio') ? (
                  <>
                    <audio controls>
                      <source src={x?.fileURL} type="audio/webm" />
                    </audio>
                    <div
                      className="desc primary-click-text"
                      style={{ fontWeight: 500 }}
                    >
                      {displayName}
                    </div>
                  </>
                ) : (
                  <>
                    <img
                      src={doc}
                      className="img-preview"
                      loading="lazy"
                      width="50"
                      height="50"
                      alt="doc"
                    />
                    <div
                      className="desc primary-click-text"
                      style={{ fontWeight: 500 }}
                    >
                      {displayName}
                    </div>
                  </>
                )}
              </span>
            )
          })
        ) : (
          <div className="desc">N/A</div>
        )}
      </div>

      <div id="viewer-container" style={viewerStyle}>
        <Viewer
          visible={openViewer}
          onClose={() => {
            setOpenViewer(false)
          }}
          images={[{ src: fileUrl, alt: fileName, downloadUrl: fileUrl }]}
          downloadable={true}
          noImgDetails={true}
          changeable={false}
          rotatable={false}
          showTotal={false}
          scalable={false}
          zoomSpeed={0.1}
          zIndex={2000}
        />
      </div>
    </>
  )
}
